export default "/dist/files/icon_infos_pratiques.d03080deb8574e71b6b54b08d94b4988.svg";